import { render, staticRenderFns } from "./RoyaltyIncentiveSLD.vue?vue&type=template&id=506a3080&"
import script from "./RoyaltyIncentiveSLD.vue?vue&type=script&lang=js&"
export * from "./RoyaltyIncentiveSLD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports